<div class="row pt-2 pb-2">
    <div class="col-sm-9">
        <h4 class="page-title">Device Log</h4>
    </div>
    <div class="col-sm-3"></div>
</div>

<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <div class="table-responsive">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                    class="table table-bordered table-striped table-hover text-center">
                        <thead >
                            <tr>
                                <th>Device ID</th>
                                <th>Air Quality Index</th>
                                <th>Water Level</th>
                                <th>Network Signal</th>
                                <th>Feedback</th>
                                <th>Date Time</th>
                                <th>Received Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let tData of rowData; let i = index">
                                <td>{{tData.device_id}}</td>
                                <td>{{tData.air_quality_index}}</td>
                                <td>{{tData.water_lavel}}</td>
                                <td>{{tData.network_signal}}</td>
                                <td>{{tData.s_feedback}}</td>
                                <td>{{tData.date_time | date:'dd-MM-yyyy HH:mm:ss'}}</td>
                                <td>{{tData.received_time | date:'dd-MM-yyyy HH:mm:ss'}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>